import React from "react";
import Navbar from "./components/Nav/Navbar";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// import ProtectedRoute from "./api/protected.route";
import DashboardPage from "./pages/DashboardPage";
import TripMasterPage from "./pages/TripMasterPage";
import Vehicle from "./pages/VehiclePage";
import UserPage from "./pages/UserPage";
import LockPage from "./pages/LockPage";
import LoginPage from "./pages/LoginPage.js";
import Footer from "./components/Footer/Footer";
import ReportsPage from "./pages/ReportsPage";
import CompanyPage from "./pages/CompanyPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const isLoggedInAdminOrSuperadmin =
    sessionStorage.getItem("token") &&
    (sessionStorage.getItem("role") === "admin" ||
      sessionStorage.getItem("role") === "superadmin" ||
      sessionStorage.getItem("role") === "tag8superadmin");

  const isLoggedInTag8SuperAdmin =
    sessionStorage.getItem("token") &&
    sessionStorage.getItem("role") === "tag8superadmin";

  return (
    <>
      <Router>
        <Navbar />

        <Routes>
          <Route
            exact
            path="/"
            element={
              !isLoggedInAdminOrSuperadmin ? (
                <LoginPage />
              ) : (
                <Navigate to={"/trip"} />
              )
            }
          />
          <Route
            exact
            path="/trip"
            element={
              isLoggedInAdminOrSuperadmin ? (
                <TripMasterPage />
              ) : (
                <Navigate to={"/"} />
              )
            }
          />
          <Route
            exact
            path="/lock"
            element={
              isLoggedInAdminOrSuperadmin ? <LockPage /> : <Navigate to={"/"} />
            }
          />
          <Route
            exact
            path="/user"
            element={
              isLoggedInAdminOrSuperadmin ? <UserPage /> : <Navigate to={"/"} />
            }
          />
          <Route
            path="/company"
            element={
              isLoggedInTag8SuperAdmin ? <CompanyPage /> : <Navigate to={"/"} />
            }
          />
          {/* {sessionStorage.getItem("token") ? ( */}
          {/* <> */}
          {/* <Route exact path="/dashboard" element={<DashboardPage />} /> */}
          {/* <Route exact path="/trip" element={<TripMasterPage />} /> */}
          {/* <Route exact path="/vehicle" element={<Vehicle />} /> */}
          {/* <Route exact path="/reports" element={<ReportsPage />} /> */}
          {/* </> */}
          {/* ) : ( */}
          {/* <Route exact path="/login" element={<LoginPage />} /> */}
          {/* )} */}
        </Routes>

        <Footer />
        <ToastContainer />
      </Router>
    </>
  );
}

export default App;
